<template>
  <div class="popover" :class="[{ 'popover--is-visible': isVisible }]">
    <div class="popover__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popover',

  props: {
    isVisible: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.popover {
  --dotcom-popover-triangle-size: 8px;

  display: flex;
  justify-content: center;
  position: absolute;
  top: 100%;
  z-index: calc(var(--z-index-overlay) + 1);
  cursor: pointer;

  left: 0;
  right: 0;
  margin: auto;

  transition: opacity 300ms ease-in-out;
  opacity: 0;
  visibility: hidden;
}

.popover--is-visible {
  opacity: 1;
  visibility: visible;
}

.popover__content {
  position: relative;
  /* by using a margin the user still :hovers the component while moving the mouse down
  *the screen to the popover */
  margin: 8px 0 0 0;
  padding: 0 var(--spacing-4);
  background-color: var(--c-primary-neutral-3);
  border: 1px solid var(--c-secondary-neutral-3);
}

/* Style ul li as usual case */
.popover__content {
  ul {
    margin: 0 calc(var(--spacing-4) * -1);

    li {
      list-style: none;
      font-size: 0;
      border-bottom: 1px solid var(--c-secondary-neutral-3);

      &:last-of-type {
        border-bottom: none;
      }

      &:hover a,
      a:active {
        color: var(--c-primary-color-2);
      }
    }
  }

  ul li a {
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    color: var(--c-primary-neutral-1);
    text-align: center;

    width: 100%;
    padding: var(--spacing-4);

    cursor: pointer;
  }
}

@media (--lg) {
  .popover {
    justify-content: flex-start;
    left: calc(-1 * var(--spacing-4));
  }
}
</style>
